var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',[(_vm.isTop)?_c('polygon',{staticClass:"topPolygon",attrs:{"points":_vm.topPolygon}}):_c('polygon',{staticClass:"bottomPolygon",attrs:{"points":_vm.bottomPolygon}}),_c('polygon',{staticClass:"rightPolygon",attrs:{"points":_vm.rightPolygon}})])
}
var staticRenderFns = []

export { render, staticRenderFns }